import type { PropsWithChildren } from 'react';
import type React from 'react';

import { TooltipContext } from './hooks/context';
import { useTooltip } from './hooks/useTooltip';
import type { TooltipOptions } from './types';

export const Tooltip: React.FC<PropsWithChildren<TooltipOptions>> = ({ children, ...options }) => {
	// This can accept any props as options, e.g. `placement`, or other positioning options.
	const tooltip = useTooltip(options);
	return <TooltipContext.Provider value={tooltip}>{children}</TooltipContext.Provider>;
};
